var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9783",
    "data-name": "Group 9783",
    transform: "translate(-8612.5 17783.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9782",
    "data-name": "Group 9782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Image",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(8613 -17783)",
    fill: "#f3f3f3",
    stroke: "#039f8f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.755,0a4.751,4.751,0,0,0-.12,9.5.807.807,0,0,1,.22,0h.07A4.752,4.752,0,0,0,4.755,0Z",
    transform: "translate(8623.244 -17778.371)",
    fill: "#039f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.059,1.484a9.33,9.33,0,0,0-10.1,0A4.254,4.254,0,0,0,0,4.922,4.218,4.218,0,0,0,1.95,8.338,8.752,8.752,0,0,0,7,9.838a8.752,8.752,0,0,0,5.054-1.5A4.254,4.254,0,0,0,14.009,4.9,4.243,4.243,0,0,0,12.059,1.484Z",
    transform: "translate(8620.996 -17767.469)",
    fill: "#039f8f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.1852eb1f1b68a261b693769c7b59f801.svg";
export { ForwardRef as ReactComponent };